// extracted by mini-css-extract-plugin
export default {"MirrorControlContainerStyle":"MirrorControlContainerStyle_Xutns","MirrorControlIconStyle":"MirrorControlIconStyle_LkVfj","MirrorTextContentStyle":"MirrorTextContentStyle_qL5rN"};